(function ($) {

    //************************************
    // back to top button
    //************************************
    function backToTop() {
        $("#back-top").click(function (event) {
            event.preventDefault();
            $("body,html").animate({scrollTop: 0}, 1000);
        });

        $(window).bind("scroll", function () {
            var footertotop = ($("footer").position().top);
            var scrolltop = $(document).scrollTop() + window.innerHeight;
            var difference = scrolltop - footertotop;

            if (scrolltop > footertotop) {
                $("#back-top").css({"bottom": difference});
            } else {
                $("#back-top").css({"bottom": 20});
            }

            if ($(window).scrollTop() > 500) {
                $("#back-top").addClass("active");
            } else {
                $("#back-top").removeClass("active");
            }
        });
    }

    backToTop();

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/scroll-top.es6